import * as React from "react";
import { classNames } from "../uitk-react-utils/index.js";
export function UitkCardLink({
  children,
  style
}) {
  const childrenArray = React.Children.toArray(children);
  const firstChild = childrenArray[0];
  const decoratedFirstChild = React.cloneElement(
    firstChild,
    {
      className: classNames(firstChild.props.className, "uitk-card-link"),
      style
    },
    /* @__PURE__ */ React.createElement("span", { className: "is-visually-hidden" }, firstChild.props.children)
  );
  if (!childrenArray || childrenArray.length !== 1) {
    console.warn(`UitkCardLink uses the first child element. ${childrenArray.length} children found.`);
  }
  return decoratedFirstChild;
}
;
UitkCardLink.displayName = "UitkCardLink";
export const UitkCardAlohaLink = UitkCardLink;
